module.exports = __webpack_public_path__ + "static/img/1.8dc83d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gczp/images/1.png
// module id = kE2a
// module chunks = 1